import styled from 'styled-components';
import Box from '@rsos/base-components/Box';

export const Wrapper = styled(Box).attrs({ padding: 3 })`
  color: white;
  width: 100%;
`;

export const ButtonWrapper = styled(Box).attrs({
  horizontal: true,
  alignContent: 'center',
})`
  gap: 11.25px;
`;

export const IconContainer = styled(Box).attrs({
  width: 13.5,
  height: 13.5,
  justify: 'center',
  align: 'center',
})`
  cursor: pointer;
  svg {
    width: 100%;
    height: 100%;
  }
  /* for some icons that are smaller than our 100% size here, we have to force them to grow */
  > div {
    flex-grow: 1;
  }
  &:hover {
    svg,
    path {
      fill: ${({ theme }) => theme.colors.heavyLineOutline};
    }
  }
`;
